import { IconWrapper } from "@insite/mobius/Icon";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import React from "react";
import { css } from "styled-components";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
export interface CustomModalStyle {
    modalStylebrands?: ModalPresentationProps;
    modalStyleprorewards?: ModalPresentationProps;
}
export const customModalStyle: CustomModalStyle = {
    modalStylebrands: {
        closeButtonProps: {
            css: css`
                padding: 0;
                top:-9px;
                right:-9px;
                position:relative;
                &:hover {
                    background: none;
                    border-color: #ffffff;
                }
                &:focus{
                
                    outline-width:0px;
                }
               
                > ${IconWrapper} {
                    color: #006AE3;
                    background-color:#006AE3
                    width: 24px;
                    height: 24px;
                    > svg {
                        width: 24px;
                        height: 24px;
                        box-shadow:none;
                       
                    }
                }
            `,
        },
        cssOverrides: {
            modalContainer: css`
                > div[class^="ContentBody"] {
                    max-width: 790px;
                    overflow: hidden;
                    height: auto;

                    display: flex;
                    flex-direction: column;
                    max-height: 100% !important;
                    border-radius: 6px;
                    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
                    border: solid 1px #bbb;
                    background-color: #fff;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                               position: fixed;
                                top: 0px;
                                border-radius: 0;
                                border: none;
                            `,
                            css`
                                position: fixed;
                                top: 0px;
                                border-radius: 0;
                                border: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
            modalBody: css`
                border-radius: 6px;
                height: 100px;
                margin: 50px;
            `,

            modalContent: css`
                padding: 0px 40px 8px 28px;

                p {
                    font-family: "Nunito Sans", sans-serif;
                    font-size: 14px;
                    font-weight: normal;

                    color: #2d2926;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 12px;
                                padding-left: 7px;
                            `,
                            css`
                                font-size: 12px;
                                padding-left: 7px;
                            `,
                        ])}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 15px 12px 8px !important;
                        `,
                        css`
                            padding: 0px 15px 12px 8px !important;
                        `,
                    ])}
                ul {
                    .adiexclusivesection {
                        margin-top: 20px;
                        margin-right: -15px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    margin-right: 0px;
                                    margin-top: 14px;
                                `,
                                css`
                                    margin-top: 14px;
                                    margin-right: 0px;
                                `,
                            ])}
                    }

                    ${GridOffset} {
                        display: block;
                        width: calc(100% + 13px);
                        margin: 0px;
                    }

                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin: 0;
                    margin-bottom: 32px;
                    width: calc(100% + 13px);
                    margin-left: -6.5px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                width: calc(100% + 14px);
                                margin-left: -7px;
                                padding-right: 3px;
                            `,

                            css`
                                width: calc(100% + 14px);
                                margin-left: -7px;
                                padding-right: 3px;
                            `,
                        ])}
                    li {
                        display: flex;
                        flex-direction: column;
                        padding: 0;
                        border-radius: 6px;
                        border: solid 1px #ddd;
                        background-color: #fff;
                        width: calc(25% - 13px);
                        margin: 0 6.5px 12px 6.5px !important;
                        cursor: pointer;
                        min-height: 70px;
                        max-height: 70px;
                        flex-basis: calc(25% - 13px);
                        max-width: calc(25% - 13px);
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px;
                                    flex-basis: calc(100% / 3 - 14px);
                                    max-width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px !important;
                                `,
                                css`
                                    width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px;
                                    flex-basis: calc(100% / 3 - 14px);
                                    max-width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px !important;
                                `,
                            ])}
                        &:hover {
                            border: solid 1px #002856;
                        }
                        a {
                            padding: 10px !important;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            text-transform: initial;
                            img,span {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                    }
                }
                .popup-scroll-height-webkit {
                    overflow-y: auto;
                    overflow-x: hidden;
                    max-height: calc(100vh - 140px);
                    min-height: initial;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding-right: 0px;
                                padding-left: 5px;
                                max-height: 75vh;
                                margin-bottom: 8px;
                            `,
                            css`
                                padding-right: 0px;
                                padding-left: 5px;
                                max-height: 75vh;
                                margin-bottom: 8px;
                            `,
                            css``,
                            css``,
                            css`
                                overflow-y: auto;
                            `,
                        ])}
                    ::-webkit-scrollbar-thumb {
                        background: #bbb;
                        border: 5px solid rgba(0, 0, 0, 0);
                        background-clip: padding-box;
                        border-radius: 14px;
                    }
                    ::-webkit-scrollbar-track {
                        background: #ffffff;
                        border-radius: 6px;
                        margin-bottom: 12px;
                    }
                    ::-webkit-scrollbar {
                        width: 14px;
                    }
                }
            `,

            modalTitle: css`
                border-bottom: 0px;
                padding: 28px 40px 0px 28px;
                .TypographyStyle{
                    font-size: 28px;
                }
                font-size:28px;
                h4 {
                    font-family: "Nunito Sans", sans-serif;
                    font-size: 28px;
                    font-weight: bold;
                    font-size: inherit;
                    text-align: left;
                    color: #002856;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 26px;
                            `,
                            css`
                                font-size: 26px;
                            `,
                        ])}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 20px 15px 2px 15px;
                        `,
                        css`
                            padding: 20px 15px 2px 15px;
                        `,
                    ])}
            `,
        },
    },
    modalStyleprorewards: {
        closeButtonProps: {
            css: css`
                padding: 0;
                top:-9px;
                right:-9px;
                position:relative;
              
                &:hover {
                    background: none;
                    border-color: #ffffff;
                }
                &:focus{
                   
                    outline-width:0px;
                }
               
                > ${IconWrapper} {
                    color: #006AE3;
                    background-color:#006AE3
                    width: 24px;
                    height: 24px;
                    > svg {
                        width: 24px;
                        height: 24px;
                        box-shadow:none;
                       
                    }
                }
            `,
        },
        cssOverrides: {
            modalContainer: css`
                > div[class^="ContentBody"] {
                    max-width: 790px;

                    height: auto;

                    display: flex;

                    border-radius: 6px;
                    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
                    border: solid 1px #bbb;
                    background-color: #fff;
                    max-height: 100% !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                               position: fixed;
                                top: 0px;
                                border-radius: 0;
                                border: none;
                            `,
                            css`
                                position: fixed;
                                top: 0px;
                                border-radius: 0;
                                border: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
            modalBody: css`
                border-radius: 6px;
                height: 100px;
                margin: 50px;
            `,

            modalContent: css`
                padding: 0px 40px 8px 28px;
                overflow: hidden;

                p {
                    font-family: "Nunito Sans", sans-serif;
                    font-size: 14px;
                    font-weight: normal;
                    margin-left: 0px;
                    padding-bottom: 0px;
                    color: #2d2926;
                    margin-left: 0px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 12px;
                                margin-left: 7px;
                                margin-bottom: 6px;
                                margin-top: 15px;
                            `,
                            css`
                                font-size: 12px;
                                margin-left: 7px;
                                margin-bottom: 6px;
                                margin-top: 15px;
                            `,
                        ])}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 15px 12px 8px !important;
                        `,
                        css`
                            padding: 0px 15px 12px 8px !important;
                        `,
                    ])}
                h4 {
                    font-family: "Nunito Sans", sans-serif;
                    font-size: 18px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.33;
                    letter-spacing: normal;
                    text-align: left;
                    color: #002856;
                    margin-left: 6px;
                }

                .gridwidth {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css``,
                            css`
                                max-width: 100%;
                            `,
                        ])}
                }
                .popup-scroll-height-webkit {
                    overflow-y: auto;
                    overflow-x: hidden;
                    max-height: calc(100vh - 140px);
                    min-height: initial;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding-right: 0px;
                                padding-left: 5px;
                                max-height: 75vh;
                                margin-bottom: 8px;
                            `,
                            css`
                                padding-right: 0px;
                                padding-left: 5px;
                                max-height: 75vh;
                                margin-bottom: 8px;
                            `,
                            css``,
                            css``,
                            css`
                                overflow-y: auto;
                            `,
                        ])}
                    ::-webkit-scrollbar-thumb {
                        background: #bbb;
                        border: 5px solid rgba(0, 0, 0, 0);
                        background-clip: padding-box;
                        border-radius: 14px;
                    }
                    ::-webkit-scrollbar-track {
                        background: #ffffff;
                        border-radius: 6px;
                        margin-bottom: 12px;
                    }
                    ::-webkit-scrollbar {
                        width: 14px;
                    }
                }
                ul {
                    ${GridOffset} {
                        width: calc(100% + 13px);
                        margin: 0px;
                    }

                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin: 0;
                    width: calc(100% + 13px);
                    margin-left: -6.5px;

                    .adiexclusivesection {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        .prorewardssection {
                            flex-basis: 100%;
                            max-width: 100%;
                            margin-right: -13px;
                            padding-top: 8px;
                            padding-bottom: 10px;
                            padding-left: 0px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        padding-top: 14px 0px;
                                    `,
                                    css`
                                        padding-top: 14px 0px;
                                    `,
                                ])}
                        }
                        .prorewardssectionsuppliers {
                            padding-top: 8px;
                            padding-bottom: 10px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        padding-bottom: 14px;
                                    `,
                                    css`
                                        padding-bottom: 14px;
                                    `,
                                ])}
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                width: calc(100% + 14px);
                                margin-left: -7px;
                                padding-right: 3px;
                            `,

                            css`
                                width: calc(100% + 14px);
                                margin-left: -7px;
                                padding-right: 3px;
                            `,
                        ])}
                    li {
                        display: flex;
                        flex-direction: column;
                        padding: 0;
                        border-radius: 6px;
                        border: solid 1px #ddd;
                        background-color: #fff;
                        width: calc(25% - 13px);
                        margin: 0 6.5px 12px 6.5px !important;
                        cursor: pointer;
                        min-height: 70px;
                        max-height: 70px;
                        flex-basis: calc(25% - 13px);
                        max-width: calc(25% - 13px);
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px;
                                    flex-basis: calc(100% / 3 - 14px);
                                    max-width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px !important;
                                `,
                                css`
                                    width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px;
                                    flex-basis: calc(100% / 3 - 14px);
                                    max-width: calc(100% / 3 - 14px);
                                    margin: 0 7px 12px 7px !important;
                                `,
                            ])}
                        &:hover {
                            border: solid 1px #002856;
                        }
                        a {
                            padding: 10px !important;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            text-transform: initial;
                            img,span {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                    }
                }
            `,

            modalTitle: css`
                border-bottom: 0px;
                padding: 18px 20px 2px 28px;
                .prorewardsheadingsection {
                    .prorewardsicon {
                        flex-basis: 8.5%;
                        max-width: 8.5%;
                        padding-bottom: 0px;
                        padding-right: 0px;
                        padding-top: 0px;
                        margin-right: -15px;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    flex-basis: 13%;
                                    max-width: 13%;
                                    padding-top: 0px;
                                    position: relative;
                                    bottom: 3px;
                                    margin-right: 0px;
                                `,
                                css`
                                    flex-basis: 13%;
                                    max-width: 13%;
                                    padding-top: 0px;
                                    position: relative;
                                    bottom: 3px;
                                    margin-right: 0px;
                                `,
                            ])}
                        button {
                            background-color: #fff;
                            border: #fff;
                            padding: 0px;
                            &:focus {
                                outline: 0;
                            }
                        }
                    }
                    .prorewardsheading {
                        padding: 0px;
                        padding-top: 0px;
                        flex-basis: 91.5%;
                        max-width: 91.5%;
                        font-size: 28px;
                        font-weight: 700;
                        line-height: normal;
                        font-family: "Nunito Sans", sans-serif;
                        color: #002856;
                        margin: 0;
                        padding: 0;
                        border: none;
                        span {
                            &:focus {
                                outline: none;
                            }
                        }

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    flex-basis: 87%;
                                    max-width: 87%;
                                    font-size: 26px;
                                `,
                                css`
                                    flex-basis: 87%;
                                    max-width: 87%;
                                    font-size: 26px;
                                `,
                            ])}
                    }
                }
                h4 {
                    font-family: "Nunito Sans", sans-serif;
                    font-sixe: 28px;
                    font-weight: bold;
                    margin-left: 6px;
                    text-align: left;
                    color: #002856;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 26px;
                            `,
                            css`
                                font-size: 26px;
                            `,
                        ])}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 20px 15px 2px 15px;
                        `,
                        css`
                            padding: 20px 15px 2px 15px;
                        `,
                    ])}
                div {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;
                    h2 {
                    }
                    span {
                        img {
                            width: 26px;
                            margin-right: 8px;
                            margin-top: 6px;
                            height: 26px;
                        }
                    }
                }
            `,
        },
    },
};

interface CustomModelProps {
    isOpen: boolean;
    handleClose: Function;
    headline?: any;
    subheading?: string;
    children: JSX.Element;
    errorStyle: boolean;
    checkStyleCondtions?: any;
}

const styles = customModalStyle;

const ADIBrandsRewardsModal = ({
    isOpen,
    handleClose,
    headline,
    subheading,
    children,
    errorStyle,
}: CustomModelProps) => {
    const checkStyleCondtions = () => {
        if (errorStyle) {
            return styles.modalStylebrands;
        } else {
            return styles.modalStyleprorewards;
            //     var landingdiv = (document.getElementsByClassName("ContentBody") as unknown as HTMLInputElement | null );
            //    var x= document.getElementById('id')?.classList.add('YourClass')
            //     var landingdivheight=landingdiv?.className += ' class_two';

            //     document.getElementById('foo').className += ' class_two'
        }
    };

    return (
        <Modal
            headline={headline}
            sizeVariant="large"
            isOpen={isOpen}
            handleClose={() => handleClose()}
            {...checkStyleCondtions()}
        >
            {subheading && <Typography as="p">{subheading}</Typography>}
            {children}
        </Modal>
    );
};

export default ADIBrandsRewardsModal;